import type { CustomFile } from '../../types';

/*
 * Straight at the module, not through the utils/format barrel, for the same
 * reason the rest of this folder does it: a leaf that only formats a number has
 * no business pulling a barrel in behind it.
 */
import bytes from '../../../format/bytes';

// ----------------------------------------------------------------------------

const errorMessages = {
    accept: function (file: CustomFile): string {
        return `File type or extension '${file.type || getFileExtensionLabel(file)}' is not allowed.`;
    },
    extension: function (file: CustomFile): string {
        return `File extension '${getFileExtensionLabel(file)}' is not allowed.`;
    },
    size: function (file: CustomFile, size: number): string {
        return `File size (${bytes(file.size, 1)}) exceeds the limit (${bytes(size, 1)}).`;
    },
    type: function (file: CustomFile): string {
        return `File type '${file.type}' is not allowed.`;
    },
};

// ----------------------------------------------------------------------------

function getFileExtensionLabel(file: CustomFile): string {
    if (file.extension == null || file.extension.trim() === '') {
        return '(none)';
    }

    return file.extension;
}

/*
 * A thrown value only carries a message when it is an Error; anything else gets
 * the caller's own words rather than a stringified object.
 */
function toMessage(err: unknown, fallback: string): string {
    return err instanceof Error ? err.message : fallback;
}

// ----------------------------------------------------------------------------

export { errorMessages, getFileExtensionLabel, toMessage };
